export enum NakakaEnum {
    istirak_nafakasi =19,
    yoksulluk_nafakasi = 20,
    yargilama_gideri = 22,
    mahkeme_vekalet_ucreti = 23,
    tedbir_nafakasi = 24,
    yardim_nafakasi = 32,


}

export enum NakakaEnumLabel {
    istirak_nafakasi = "İştirak Nakası",
    yoksulluk_nafakasi = "Yoksulluk Nafakası",
    yargilama_gideri = "Yargılama  Gideri",
    mahkeme_vekalet_ucreti = "Mahkeme Vekalet Ücreti",
    tedbir_nafakasi = "Tedbir Nafakası",
    yardim_nafakasi = "Yardım Nafakası",
}